import React from 'react';
import Layout from '../components/Layout';

import ServiceLayout1 from "../components/servicepage/ServiceHead";
import Contactform from "../components/contactform";
import ScrollingText from '../components/lettersslider';
import OfficeLocation from '../components/officelocation';
import useScrollTransition from '../useScrollTransition';


const ContactUs: React.FC = () => {
  useScrollTransition();
  return (
    <Layout>
      <ServiceLayout1/>
      <ScrollingText/>
     
      <Contactform/>
      <OfficeLocation/>
      

    </Layout>
  );
}

export default ContactUs;
